import * as React from "react";
import Style from "../assets/jsStyles/index";
import { Headline, Instructions, Video } from "../config/info";
const Info = (props) => {
    return (
        <div className="infoPart" style={Style.infoPart()}>
            <h2>{Headline(props.productName)}</h2>
            <div className="infoPart-Video">
                <iframe
                    width="90%"
                    height="345"
                    src={Video(props.productName)}
                    title="video"
                    allowFullScreen
                    
                ></iframe>
            </div>
            <div className="infoPart-info">
                <h4>Instructions to follow</h4>
                {Instructions(props.productName)}
            </div>
        </div>
    );
};

export default Info;
